import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { formatMoney } from '../../lib/shopify';
import { CartItem } from './CartItem';
import { ShippingMessage } from './ShippingMessage';
const EASE = [0.23, 1, 0.32, 1] as const;
export function CartDrawer() {
  const {
    lines,
    isOpen,
    close,
    subtotal,
    currencyCode,
    checkout,
    checkoutState
  } = useCart();
  return <AnimatePresence data-id="element-212" data-mp="31bnq48lweuid">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: EASE
      }} onClick={close} className="fixed inset-0 z-50 bg-beat-black/70 backdrop-blur-sm" aria-hidden="true" data-id="element-213" data-mp="3fbotpvtjsg1j" />

          <motion.aside role="dialog" aria-label="Cart" initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} className="fixed inset-y-0 right-0 z-50 flex w-full max-w-md flex-col bg-beat-black shadow-2xl sm:border-l sm:border-white/10" data-id="element-214" data-mp="1g04dw39x125t">
            <header className="flex items-center justify-between px-5 py-5 md:px-7" data-id="element-215" data-mp="v1fb56b570z8">
              <h2 className="text-lg font-medium tracking-tight" data-id="element-216" data-mp="z2qsypnryhwv">
                Your cart
                {lines.length > 0 && <span className="ml-2 text-white/40" data-id="element-217" data-mp="13zh91czkxdia">{lines.length}</span>}
              </h2>
              <button type="button" onClick={close} aria-label="Close cart" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/20 transition-colors duration-150 hover:border-white hover:bg-white hover:text-beat-black" data-id="element-218" data-mp="190wqyw6gn3wg">
                <X size={18} data-id="element-219" data-mp="37pdj2815fjyh" />
              </button>
            </header>

            {lines.length === 0 ? <div className="flex flex-1 flex-col items-center justify-center gap-6 px-8 text-center" data-id="element-220" data-mp="32rlspig5k5we">
                <p className="text-lg text-white/50" data-id="element-221" data-mp="3hocrpqlwzflh">Nothing here yet.</p>
                <Link to="/shop" onClick={close} className="inline-flex min-h-[52px] items-center rounded-full bg-beat-red px-7 text-base font-medium text-white transition-colors duration-150 hover:bg-white hover:text-beat-black" data-id="element-222" data-mp="3cp9ma520v7cz">
                  Shop BEAT
                </Link>
              </div> : <>
                <ul className="flex-1 overflow-y-auto px-5 md:px-7" data-id="element-223" data-mp="3vey4qyoosvbg">
                  {lines.map(line => <CartItem key={line.product.handle} line={line} onNavigate={close} data-id="element-224" data-mp="d936sawiczog" />)}
                </ul>

                <footer className="border-t border-white/10 px-5 py-6 md:px-7" data-id="element-225" data-mp="rxv5nndsyic8">
                  <ShippingMessage subtotal={subtotal} className="mb-5" data-id="element-226" data-mp="wvwr2eypatqv" />

                  <div className="mb-5 flex items-baseline justify-between" data-id="element-227" data-mp="iw5fslzkjrgk">
                    <span className="text-base text-white/55" data-id="element-228" data-mp="iy83v0h5vain">Subtotal</span>
                    <span className="text-xl font-medium tabular-nums" data-id="element-229" data-mp="nt5ay1uvr9sw">
                      {formatMoney(subtotal, currencyCode)}
                    </span>
                  </div>

                  <button type="button" onClick={checkout} disabled={checkoutState === 'loading'} className="inline-flex min-h-[54px] w-full items-center justify-center rounded-full bg-beat-red px-7 text-base font-medium text-white transition-colors duration-150 hover:bg-white hover:text-beat-black disabled:opacity-60" data-id="element-230" data-mp="dxke0i4o4zq0">
                    {checkoutState === 'loading' ? 'Taking you to checkout…' : 'Checkout'}
                  </button>

                  <button type="button" onClick={close} className="mt-3 inline-flex min-h-[48px] w-full items-center justify-center text-base text-white/50 transition-colors duration-150 hover:text-white" data-id="element-231" data-mp="thvmb4fc47im">
                    Continue shopping
                  </button>

                  {checkoutState === 'unavailable' && <p className="mt-4 text-sm leading-relaxed text-white/45" data-id="element-232" data-mp="9t3czfvyth65">
                      Checkout opens once Shopify is connected. Add the store
                      domain and Storefront token in{' '}
                      <span className="text-white/70" data-id="element-233" data-mp="v1288mfja5o">lib/shopify.ts</span>.
                    </p>}
                  {checkoutState === 'error' && <p className="mt-4 text-sm text-white/45" data-id="element-234" data-mp="1v77pi5sllhec">
                      Something went wrong reaching checkout. Try again.
                    </p>}
                </footer>
              </>}
          </motion.aside>
        </>}
    </AnimatePresence>;
}